import React, { Suspense, lazy, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { AiModeProvider } from './context/AiModeContext.jsx';

const LazyToastViewport = lazy(() => import("./components/ToastViewport.jsx"));

const runWhenIdle = (callback, timeout = 1200) => {
  if (typeof window === "undefined") return () => {};
  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(callback, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, timeout);
  return () => window.clearTimeout(id);
};

function DeferredToastViewport() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (enabled) return undefined;
    return runWhenIdle(() => setEnabled(true), 1800);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <Suspense fallback={null}>
      <LazyToastViewport />
    </Suspense>
  );
}

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AiModeProvider>
          <App />
        </AiModeProvider>
      </ThemeProvider>
      <DeferredToastViewport />
    </BrowserRouter>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(app);
}
